import {
  CUSTOMER_TEXT,
  LOAD_MORE_ITEMS,
  ORDER_ID,
  ORDER_STATUS,
  ORDER_TEXT,
  RETURN_TEXT,
  RENDER_TYPE,
  RETURNED_ITEMS,
  SCAN_END,
  SEARCH_OPEN,
  SET_BOARD_ITEM,
  SET_ODS_CART,
  SET_ODS_NEW,
  SET_ODS_NOTIF,
  ORDER_AGG_TAB,
  ODS_TEXT,
} from "../Actions/paginationActions";
import { SEARCH_TEXT } from "../Actions/paginationActions";
import { SET_LOADING } from "../Actions/paginationActions";
import { SET_APPDRAWER } from "../Actions/paginationActions";
import { SEARCH_TEXTI } from "../Actions/paginationActions";
import { SET_LOADINGI } from "../Actions/paginationActions";
import { SET_FOCUS } from "../Actions/paginationActions";
import { ADD_TOGGLE_MODE, SET_AMT_FOCUS } from "../Actions/paginationActions";
import { SET_MOBILE_POS } from "../Actions/paginationActions";
import { BARCODE_FOCUS } from "../Actions/paginationActions";
import { SET_DEVICE_TYPE } from "../Actions/paginationActions";
import { SELECT_BATCH_STAT } from "./../Actions/paginationActions";

const initState = {
  currentPage: 1,
  totalResults: "",
  searchText: "",
  loading: false,
  searchTextI: "",
  loadingI: false,
  appDrawer: false,
  focus: false,
  toggleMode: false,
  enterAmtFocus: true,
  mobilePos: false,
  deviceType: "",
  barcode_focus: false,
  order_text: "",
  return_text: "",
  ods_text: "",
  order_status: false,
  order_Id: "",
  scan_end: false,
  select_batch_status: false,
  customer_text: null,
  search_open: false,
  renderType: "",
  boardItem: null,
  addNewOds: false,
  odsCart: [],
  returnedProducts: [],
  isOdsNotif: false,
  orderAggTab: "",
};

export const paginationReducer = (state = initState, action) => {
  switch (action.type) {
    case LOAD_MORE_ITEMS: {
      return { ...state, currentPage: action.payload };
    }
    case SEARCH_TEXT: {
      return { ...state, searchText: action.payload };
    }
    case SET_LOADING: {
      return { ...state, loading: action.payload };
    }
    case SEARCH_TEXTI: {
      return { ...state, searchTextI: action.payload };
    }
    case SET_LOADINGI: {
      return { ...state, loadingI: action.payload };
    }
    case SET_APPDRAWER: {
      return { ...state, appDrawer: action.payload };
    }
    case SET_FOCUS: {
      return { ...state, focus: action.payload };
    }
    case ADD_TOGGLE_MODE: {
      return { ...state, toggleMode: action.payload };
    }
    case SET_AMT_FOCUS: {
      return { ...state, enterAmtFocus: action.payload };
    }
    case SET_MOBILE_POS: {
      return { ...state, mobilePos: action.payload };
    }
    case SET_DEVICE_TYPE: {
      return { ...state, deviceType: action.payload };
    }
    case BARCODE_FOCUS: {
      return { ...state, barcode_focus: action.payload };
    }
    case ORDER_TEXT: {
      return { ...state, order_text: action.payload };
    }
    case ORDER_STATUS: {
      return { ...state, order_status: action.payload };
    }
    case ORDER_ID: {
      return { ...state, order_Id: action.payload };
    }
    case RETURN_TEXT: {
      return { ...state, return_text: action.payload };
    }
    case ODS_TEXT: {
      return { ...state, ods_text: action.payload };
    }
    case CUSTOMER_TEXT: {
      return { ...state, customer_text: action.payload };
    }
    case SCAN_END: {
      return { ...state, scan_end: action.payload };
    }
    case SELECT_BATCH_STAT: {
      return { ...state, select_batch_status: action.payload };
    }
    case SEARCH_OPEN: {
      return { ...state, search_open: action.payload };
    }
    case RENDER_TYPE: {
      return { ...state, render_type: action.payload };
    }
    case SET_BOARD_ITEM: {
      return { ...state, boardItem: action.payload };
    }
    case SET_ODS_NEW: {
      return { ...state, addNewOds: action.payload };
    }
    case SET_ODS_CART: {
      return { ...state, odsCart: action.payload };
    }
    case RETURNED_ITEMS: {
      return { ...state, returnedProducts: action.payload };
    }
    case SET_ODS_NOTIF: {
      return { ...state, isOdsNotif: action.payload };
    }
    case ORDER_AGG_TAB: {
      return { ...state, orderAggTab: action.payload };
    }
    default:
      return state;
  }
};

// export const searchTextVal = state => state.pagination.searchText;
export const getFocus = (state) => state.pagination.focus;
export const getMobilePos = (state) => state.pagination.mobilePos;
export const getBarcodeStat = (state) => state.pagination.barcode_focus;
export const getDeviceType = (state) => state.pagination.deviceType;
export const getOrderStatus = (state) => state.pagination.order_status;
export const getOrderId = (state) => state.pagination.order_Id;
export const getBatchStat = (state) => state.pagination.select_batch_status;
export const getCustomerText = (state) => state.pagination.customer_text;
export const getOrderText = (state) => state.pagination.order_text;
export const getReturnText = (state) => state.pagination.return_text;
export const getOdsText = (state) => state.pagination.ods_text;
export const getSearchOpen = (state) => state.pagination.search_open;
export const getRenderType = (state) => state.pagination.render_type;
export const getBoardItem = (state) => state.pagination.boardItem;
export const getAddNewOds = (state) => state.pagination.addNewOds;
export const getOdsCart = (state) => state.pagination.odsCart;
export const getReturnedProducts = (state) => state.pagination.returnedProducts;
export const getOdsNotif = (state) => state.pagination.isOdsNotif;
export const getOrderAggTab = (state) => state.pagination.orderAggTab;
